import { render, staticRenderFns } from "./BetgameAccessibility.vue?vue&type=template&id=f3dda354&scoped=true"
import script from "./BetgameAccessibility.vue?vue&type=script&lang=js"
export * from "./BetgameAccessibility.vue?vue&type=script&lang=js"
import style0 from "./BetgameAccessibility.vue?vue&type=style&index=0&id=f3dda354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dda354",
  null
  
)

export default component.exports